import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=1ea6a142&"
import script from "./UserSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports